import { apiClient } from './api-client';

/**
 * Badge counts for the app nav rail (BFF `GET /nav/counts`). A key is absent
 * when the count is unknown or not meant for this user — never a placeholder 0.
 */
export interface NavCounts {
  /** My tickets waiting on me (new + in_progress, primary or secondary), and how many are past SLA. */
  tickets?: { waiting: number; breached: number };
  /** The unassigned queue, for users who can pick it up. */
  inbox?: { unassigned: number };
  /** Chats waiting to be picked up. */
  liveChat?: { waiting: number };
}

export const navService = {
  /** `fresh` skips the BFF's short cache — for a refresh right after a live event. */
  async getCounts(fresh = false): Promise<NavCounts> {
    const response = await apiClient.get('/nav/counts', fresh ? { params: { fresh: 'true' } } : undefined);
    return response.data ?? {};
  },
};
